import http from '../_httpHandlers';
import { config } from '../_config';
import { ISetting, ISettingDownloadService } from '../_types/interfaces';

const uri = config.backendAddress;

const getSettings = async (): Promise<ISetting> => {
    return await http.get(`${uri}/GetConfigForDownloadService`);
};

const updateSettings = async (services: ISetting): Promise<void> => {
    return await http.post(`${uri}/UpdateConfigForDownloadService`, services);
};

export const settingService: ISettingDownloadService = {
    getSettings,
    updateSettings,
};